import React from 'react';

import { TableBasicInput } from './table-basic-input';

export interface TableIntegerInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  hasError?: boolean;
}

/**
 * Specialized integer input for table inline editing
 * Only allows digits (0-9), no decimals
 */
export const TableIntegerInput: React.FC<TableIntegerInputProps> = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  disabled,
  autoFocus,
  className,
  hasError = false,
}) => {
  return (
    <TableBasicInput
      value={value ?? ''}
      onChange={(strValue) => {
        if (strValue === null) {
          onChange(null);
        } else {
          const parsed = parseInt(strValue);
          if (!isNaN(parsed) && parsed !== value) {
            onChange(parsed);
          }
        }
      }}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      disabled={disabled}
      autoFocus={autoFocus}
      className={className}
      hasError={hasError}
      align="right"
      onInputChange={(e) => {
        // Allow only digits
        if (/[^0-9]/.test(e.target.value)) {
          e.target.value = e.target.value.replace(/[^0-9]/, '');
        }
      }}
    />
  );
};
